import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Isi from './app';
import './styles.scss';
export default class IsiModule{
	constructor(config,$modules){
		let _config = $.extend({},config,true);
		let pagePosition = $.extend({},_config["page-position"]);
		$modules.each((index,el)=>{
			let $module = $(el);
	    	if($module.hasClass('module-loaded')){
	    		return;
	    	}
	    	let isInline = true; 
	    	if(window.medscape.isMobile){
	    		isInline = $module.data("mobile-display") ? $module.data("mobile-display")!="toggle" : true;
	    	}
	    	else{
	    		isInline = $module.data("desktop-display") ? $module.data("desktop-display")!="toggle" : true;	
	    	}
			const props = {
				config: _config,
				isInline: isInline
			}

			ReactDOM.render(React.createElement(Isi,props),el);
			$module.addClass('module-loaded');
		})

	}
}
IsiModule.selector = '[data-module="ISI"]';
IsiModule.init = (config,route,$module) => {
	$module = $module || $(IsiModule.selector);
	if($module.length>0){
		new IsiModule(config,$module);
	}
}




// WEBPACK FOOTER //
// ./src/app/isi/index.js